/**
 * 枚举：变量类型
 * @enum Session 会话变量
 * @enum Context 上下文变量
 */
export enum VarType {
  Session = "Session",
  Context = "Context"
}